/**
 * User Preferences Actions 
 * @author: Aderbal Nunes <aderbal@zenitetecnologia.com.br>
 * @since: 17/03/2020
 * 
 * Copyright 2020 Zenite Tecnologia.
 */
export const ACTION_USER_PREF_ADD = 'ACTION_USER_PREF_ADD';
export const ACTION_USER_PREF_SAVE = 'ACTION_USER_PREF_SAVE';